import { useState } from "react";
import "./Contact.css";
import backgroundVideo from '../images/homepage.mp4'


export default function Contact() {
  //creates a form to gather user data to send to 127.0.0.1:8000/api/contact/ using fetch
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    fetch("https://high-and-fly-1.onrender.com/api/contact/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(form)
    });
    setForm({
      name: "",
      email: "",
      message: "",
    });
  }

    return (<>
    <div className="page">
        <video autoPlay loop muted playsInline className="background-video">
            <source src={backgroundVideo} type="video/mp4" />
        </video>
    <div className="content_in_contact">
    <h1>Call us</h1>
    <a href="tel:+15023652611" className="phone_number">(502) 365-2611</a>
    <h2>Or send us a message!</h2>
    </div>
    <form onSubmit={handleSubmit}>
        <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={form.name}
            onChange={handleChange}
            style={{
              borderRadius: '8px',
              border: '1px solid #ccc',
              padding: '10px',
              marginBottom: '10px',
              width: '50%',
            }}
        />
        <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={form.email}
            onChange={handleChange}
            style={{
              borderRadius: '8px',
              border: '1px solid #ccc',
              padding: '10px',
              marginBottom: '10px',
              width: '50%',
            }}
        />
        <textarea
            name="message"
            placeholder="Your Message"
            value={form.message}
            onChange={handleChange}
            style={{
              borderRadius: '8px',
              border: '1px solid #ccc',
              padding: '10px',
              marginBottom: '10px',
              width: '75%',
              height: '10vh',
            }}
        />
        <button type="submit">Send Message</button>
    </form>
    </div>
    </>)

}